import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ScreeningStatus, ScreeningType } from '@estercare/ester-shared'
import { ScreeningQuestionnaire } from '../../../../components/screening/ScreeningQuestionnaire'
import {
  useSelectFormattedScreeningHandledDate,
  useSelectLatestScreeningType,
  useSelectScreeningId,
  useSelectScreeningStatus,
} from '../../../../state/selectors'

const SCREENING_PATH = '/portal/health-services/screening'

export const Questions = () => {
  const navigate = useNavigate()

  const screeningStatus = useSelectScreeningStatus()
  const { latestScreeningId } = useSelectScreeningId()
  const latestScreeningType = useSelectLatestScreeningType()
  const screeningHandledDate = useSelectFormattedScreeningHandledDate()

  const isFollowUp = latestScreeningType === ScreeningType.FOLLOW_UP
  const isHandled = screeningStatus === ScreeningStatus.HANDLED || screeningStatus === ScreeningStatus.FOLLOW_UP_HANDLED

  useEffect(() => {
    if (isHandled) {
      navigate(SCREENING_PATH)
    }
  }, [isHandled, navigate])

  if (isHandled) return null

  return (
    <ScreeningQuestionnaire
      screeningId={latestScreeningId}
      submitPath={`${SCREENING_PATH}/submit`}
      closePath={SCREENING_PATH}
      parentScreeningDate={isFollowUp ? screeningHandledDate : null}
    />
  )
}
